<template>
  <div id="pmcaffHeader" class="pmcaff-header cl">
    <div class="header-pc cl">
      <div class="header-left fl">
        <h1 class="logo fl">
          <a :href="pmUrl"
            ><img src="https://img.pmcaff.com/FqEYF-f1C23K_do0AZD69X5rtVBH"
          /></a>
        </h1>
      </div>
      <div class="header-center">
        <ul class="nav">
          <li class="fl">
            <a :href="coUrl">咖啡日报</a>
          </li>
          <li class="fl">
            <a :href="`${pmUrl}feed`">社区</a>
          </li>
          <!-- <li class="fl">
                        <a :href="`${pmUrl}job`">招聘</a>
                    </li> -->
          <li class="fl">
            <a :href="`${pmUrl}activity`">活动</a>
          </li>
          <li :class="['fl hdy', showOurworkNew ? 'new' : '']">
            <a
              href="https://www.duiyou360.com?utm_source=pmcaff"
              target="_blank"
              @click="ourworkClick"
            >
              云队友
              <div class="hdy-tip">
                <p>新用户发布职位<br />限时领取1000元现金券</p>
              </div>
            </a>
          </li>
          <li v-if="false" class="fl">
            <a
              href="http://www.waibaodashi.com?utm_source=pmcaff"
              target="_blank"
              >外包大师</a
            >
          </li>
          <li class="fl" v-if="false">
            <a href="https://atdesigner.pmcaff.com" target="_blank">创意协同</a>
          </li>
          <li class="fl btn">
            <a :href="`${pmUrl}write/discuss?form=topbar`">提问</a>
          </li>
          <li class="fl btn">
            <a :href="`${pmUrl}write/article?form=topbar`">创作</a>
          </li>
        </ul>
      </div>
      <div class="header-right fr">
        <ul class="nav">
          <li v-if="false" class="fl">
            <a :href="`${pmUrl}im`" target="_blank">群聊</a>
          </li>
          <li class="fl">
            <a :href="`${pmUrl}app`" target="_blank">APP 下载</a>
          </li>
          <li class="fl">
            <a :href="`${pmUrl}search`"
              ><i class="icon iconfont icon-search"></i
            ></a>
          </li>
          <li class="notices fl" v-if="auth">
            <a :href="`${pmUrl}user/notification/${userInfo.id}`">
              <i class="icon iconfont icon-notice"></i>
              <span class="count" v-if="noticeCount > 0">{{
                noticeCount
              }}</span>
            </a>
          </li>
          <li class="user dropdown fl" v-if="auth">
            <div :class="['avatar', userInfo.vip ? 'avatar-vip' : '']">
              <div class="inner">
                <img :src="userProfile.portrait" />
              </div>
              <div class="plus">
                <img
                  v-if="userInfo.vip"
                  src="https://img.pmcaff.com/FomumCcw1J2fDH-81i0nfMgfByL3"
                />
                <img
                  v-else
                  src="https://img.pmcaff.com/FhhZglB_S7SusLF5jNQHJcI-yjRM"
                />
              </div>
            </div>
            <div class="menu">
              <ul>
                <li :class="['name', userInfo.vip ? 'name-vip' : '']">
                  <div class="nickname">
                    <span class="inner">{{ userProfile.name }}</span>
                    <img
                      v-if="userInfo.vip"
                      src="https://img.pmcaff.com/Fkvh-kD0xve4oRwuOL7AJOA5yOIC"
                    />
                    <img
                      v-else
                      src="https://img.pmcaff.com/FmO-1Kmdwa5t4GNWalnbWuwAD0ft"
                    />
                  </div>
                  <a v-if="userInfo.vip" :href="`${pmUrl}user/plus?from=menu`"
                    >Plus 会员<i class="icon iconfont icon-arrow-right"></i
                  ></a>
                  <a v-else :href="`${pmUrl}user/plus?from=menu`"
                    >立即开通 Plus 会员<i
                      class="icon iconfont icon-arrow-right"
                    ></i
                  ></a>
                </li>
                <li>
                  <a :href="`${pmUrl}user/profile/${userInfo.id}`">个人中心</a>
                </li>
                <li id="inviteCode">
                  <a :href="`${pmUrl}user/invite`">邀请码</a>
                </li>
                <li>
                  <a :href="`${pmUrl}user/profile/${userInfo.id}?tab=recommend`"
                    >我的推荐</a
                  >
                </li>
                <li>
                  <a :href="`${pmUrl}user/profile/${userInfo.id}?tab=collect`"
                    >我的收藏</a
                  >
                </li>
                <li>
                  <a :href="`${coUrl}user/coffeebeans`">我的资产</a>
                </li>
                <li>
                  <a :href="`${pmUrl}user/setting`">个人设置</a>
                </li>
                <li>
                  <a :href="`${pmUrl}discuss/1000000000133625`">建议反馈</a>
                </li>
                <li>
                  <a href="" @click.prevent="logout">退出登录</a>
                </li>
              </ul>
            </div>
          </li>
          <template v-else>
            <li class="fl">
              <a :href="`${pmUrl}user/login?from=topbar`">登录</a>
            </li>
            <li class="fl">
              <a :href="`${pmUrl}user/register?from=topbar`">注册</a>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="header-mo cl">
      <div class="header-wrap">
        <div class="header-left fl" @click="openDrawer('nav')">
          <h1 class="logo fl">
            <img src="https://img.pmcaff.com/FqEYF-f1C23K_do0AZD69X5rtVBH" />
          </h1>
          <span class="count fl" v-if="auth && noticeCount > 0">{{
            noticeCount
          }}</span>
          <i class="icon iconfont icon-arrow-up icon-switch fl"></i>
          <i class="icon iconfont icon-arrow-down icon-switch fl"></i>
        </div>
        <div class="header-left fr">
          <div class="share-btn" @click="openDrawer('write')">
            <i class="icon iconfont icon-add"></i>
          </div>
        </div>
      </div>
      <div class="header-drawer nav-drawer">
        <ul>
          <template v-if="!auth">
            <li>
              <a :href="`${pmUrl}user/login`">登录</a>
            </li>
            <li>
              <a :href="`${pmUrl}user/register`">注册</a>
            </li>
            <li class="hr"></li>
          </template>
          <li>
            <a :href="coUrl">咖啡日报</a>
          </li>
          <li>
            <a :href="`${pmUrl}feed`">社区</a>
          </li>
          <!-- <li>
                        <a :href="`${pmUrl}job`">招聘</a>
                    </li> -->
          <li>
            <a :href="`${pmUrl}activity`">活动</a>
          </li>
          <li>
            <a
              href="https://www.duiyou360.com?utm_source=pmcaff"
              target="_blank"
              class="cl"
            >
              <span class="fl">云队友</span>
              <span class="text fr">新用户发职位 领1000元现金券</span>
            </a>
          </li>
          <li v-if="false">
            <a
              href="http://www.waibaodashi.com?utm_source=pmcaff"
              target="_blank"
              >外包大师</a
            >
          </li>
          <li v-if="false">
            <a href="https://atdesigner.pmcaff.com/" target="_blank"
              >创意协同</a
            >
          </li>
          <li v-if="!isAndroidApp && !isIOSApp">
            <a :href="`${pmUrl}app`" target="_blank">
              APP 下载
              <span class="fr">
                <i class="icon iconfont icon-ios"></i>
                <i class="icon iconfont icon-android"></i>
              </span>
            </a>
          </li>
          <li class="hr"></li>
          <li class="notices" v-if="auth">
            <a :href="`${pmUrl}user/notification/${userInfo.id}`">
              通知中心
              <span class="count fr" v-if="noticeCount > 0">{{
                noticeCount
              }}</span>
            </a>
          </li>
          <li>
            <a :href="`${pmUrl}search`">搜索</a>
          </li>
          <template v-if="auth">
            <li class="hr"></li>
            <li>
              <a :href="`${pmUrl}user/profile/${userInfo.id}`">
                个人中心
                <img :src="userProfile.portrait" class="avatar fr" />
              </a>
            </li>
            <li>
              <a :href="`${pmUrl}user/invite`">邀请码</a>
            </li>
            <li>
              <a :href="`${pmUrl}user/profile/${userInfo.id}?tab=recommend`"
                >我的推荐</a
              >
            </li>
            <li>
              <a :href="`${pmUrl}user/profile/${userInfo.id}?tab=collect`"
                >我的收藏</a
              >
            </li>
            <li>
              <a :href="`${coUrl}user/coffeebeans`">我的资产</a>
            </li>
            <li>
              <a :href="`${pmUrl}user/setting`">个人设置</a>
            </li>
          </template>
          <li class="hr"></li>
          <li>
            <a :href="`${pmUrl}discuss/1000000000133625`">建议反馈</a>
          </li>
          <li v-if="auth">
            <a href="" @click.prevent="logout">退出登录</a>
          </li>
        </ul>
      </div>
      <div class="header-drawer write-drawer">
        <ul>
          <li>
            <a :href="`${pmUrl}write/discuss?form=topbar`" class="cl">
              <span class="fl">提问</span>
              <span class="fr beans">咖啡豆+5</span>
            </a>
          </li>
          <li>
            <a :href="`${pmUrl}write/article?form=topbar`" class="cl">
              <span class="fl">创作</span>
              <span class="fr beans">咖啡豆+5</span>
            </a>
          </li>
          <li id="openContribute">
            <a href="" class="cl">
              <span class="fl">推荐文章</span>
              <span class="fr beans">咖啡豆+1</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import baseConfig from "./config";
export default {
  name: "pmcaffHeader",
  data() {
    return {
      userInfo: {},
      noticeCount: 0,
      showOurworkNew: false,
    };
  },
  computed: {
    auth() {
      return baseConfig.auth;
    },
    cookieDomain() {
      return baseConfig.getCookieDomain();
    },
    userProfile() {
      return this.userInfo.user_profile || {};
    },
    pmUrl() {
      return baseConfig.getPmUrl();
    },
    coUrl() {
      return baseConfig.getCoUrl();
    },
    header() {
      return document.getElementById("pmcaffHeader");
    },
    isIOSApp() {
      return baseConfig.isIOSApp();
    },
    isAndroidApp() {
      return baseConfig.isAndroidApp();
    },
    isNewIOSApp() {
      return baseConfig.isNewIOSApp();
    },
    isNewAndroidApp() {
      return baseConfig.isNewAndroidApp();
    },
    hasClickOurwork() {
      return window.localStorage.getItem("hasClickOurwork") || false;
    },
  },
  created() {
    if (this.isIOSApp || this.isNewAndroidApp) {
      document.body.classList.add("header-hide");
    }
    if (this.auth) {
      this.getLoginUser();
      this.getNoticeCount();
    }
    this.showOurworkNew = !this.hasClickOurwork;
  },
  mounted() {
    let vue = this;
    window.addEventListener("scroll", function (event) {
      if (vue.hasClass("write-drawer-open")) {
        vue.header.classList.remove("write-drawer-open");
      }
    });
  },
  methods: {
    ourworkClick() {
      if (!this.hasClickOurwork) {
        window.localStorage.setItem("hasClickOurwork", 1);
        this.showOurworkNew = false;
      }
    },
    getLoginUser() {
      this.axios({
        method: "get",
        url: `${this.apiURL}user/me-info`,
        params: {
          preventCache: new Date(),
        },
      }).then((resp) => {
        let res = resp.data;
        if (res.status_code == 200) {
          if (/^[0-9]*$/.test(this.auth.id)) {
            let newAuth = {
              id: res.data.id,
              token: this.auth.token,
              expires_in: this.auth.expires_in,
            };
            Cookies.set("_PMAUTH", JSON.stringify(newAuth), {
              expires: newAuth.expires_in,
              domain: this.cookieDomain,
            });
          }
          this.userInfo = res.data;
        }
      });
    },
    getNoticeCount() {
      this.axios({
        method: "get",
        url: `${this.apiURL}notifies/unread-count`,
        params: {
          preventCache: new Date(),
        },
      }).then((resp) => {
        let res = resp.data;
        if (res.status_code === 200) {
          this.noticeCount = res.data.count;
        }
      });
    },
    logout() {
      Cookies.remove("_PMAUTH", {
        domain: this.cookieDomain,
      });
      window.location.reload();
    },
    openDrawer(name) {
      let header = this.header;
      let className = `${name}-drawer-open`;
      if (
        header.className.indexOf("-drawer-open") > -1 &&
        !this.hasClass(className)
      )
        return false;
      if (name == "nav") document.body.classList.toggle("scroll-fixed");
      header.classList.toggle(className);
    },
    hasClass(className) {
      return this.header.classList.contains(className);
    },
  },
};
</script>
<style lang="scss">
@import "assets/iconfont/iconfont.css";
.scroll-fixed {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  padding: 0;
}

.header-hide {
  #pmcaffHeader {
    display: none;
  }
}

#pmcaffHeader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 60px;
  padding: 0 30px;
  background: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  color: #151515;
  font-size: 14px;
  line-height: 1.5;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "Noto Sans CJK SC", "WenQuanYi Micro Hei", Arial,
    sans-serif;
  box-sizing: border-box;
  div,
  span,
  header,
  footer,
  nav,
  section,
  aside,
  article,
  ul,
  dl,
  dt,
  dd,
  li,
  a,
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  i,
  b,
  textarea,
  button,
  input,
  select,
  figure,
  form,
  figcaption {
    padding: 0;
    margin: 0;
    list-style: none;
    font-style: normal;
    text-decoration: none;
    border: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    -webkit-font-smoothing: antialiased;
    &:focus {
      outline: none;
    }
  }
  .cl:after {
    content: " ";
    font-size: 0;
    display: block;
    height: 0;
    line-height: 0;
    clear: both;
  }
  .tcenter {
    text-align: center;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  * {
    transition: all 0.2s;
  }
  a {
    color: #151515;
  }
  .header-left,
  .header-right {
    position: relative;
    z-index: 1;
    height: 60px;
  }
  .header-center {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    text-align: center;
  }
  .logo {
    height: 100%;
    a {
      display: block;
      height: 100%;
    }
    img {
      height: 20px;
      margin-top: 20px;
      vertical-align: top;
    }
  }
  .icon-switch {
    display: none;
    height: 20px;
    margin: 20px;
    line-height: 20px;
    color: #999;
  }
  .nav {
    display: inline-block;
    li {
      padding: 0 15px;
      height: 100%;
      line-height: 60px;
      a {
        display: block;
        height: 60px;
        line-height: 60px;
        &:hover {
          color: #666;
        }
      }
      &.new {
        position: relative;
        &:after {
          position: absolute;
          top: 20px;
          right: 5px;
          content: " ";
          width: 8px;
          height: 8px;
          background: #82b64a;
          border-radius: 8px;
        }
      }
    }
    .btn {
      width: auto;
      padding: 0 5px;
      a {
        display: inline-block;
        height: 28px;
        padding: 0 10px;
        background: #82b64a;
        border-radius: 2px;
        line-height: 28px;
        color: #fff;
        &:hover {
          background: #74a342;
          color: #fff;
        }
      }
    }
    .hdy {
      a {
        position: relative;
        .hdy-tip {
          display: none;
          position: absolute;
          top: 52px;
          left: 50%;
          padding: 10px;
          line-height: 20px;
          background: rgba(0, 0, 0, 0.9);
          color: #fff;
          white-space: nowrap;
          border-radius: 2px;
          transform: translateX(-50%);
          span {
            margin: 0 10px;
            color: #333;
          }
          &:after {
            position: absolute;
            top: -6px;
            left: 50%;
            margin-left: -6px;
            content: "";
            border-top: none;
            border-left: solid 6px transparent;
            border-right: solid 6px transparent;
            border-bottom: solid 6px rgba(0, 0, 0, 0.9);
          }
        }
        &:hover {
          .hdy-tip {
            display: block;
          }
        }
      }
    }
    .notices {
      position: relative;
      .count {
        position: absolute;
        top: 14px;
        left: 20px;
        height: 16px;
        margin: 0;
        padding: 0 4px;
        text-align: center;
        line-height: 14px;
        background: #82b64a;
        border: 1px solid #fff;
        border-radius: 9px;
        box-sizing: border-box;
        font-size: 12px;
        color: #fff;
      }
    }
    .user {
      height: 60px;
      padding-right: 0;
      .avatar {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 30px;
        border-radius: 100%;
        vertical-align: middle;
        border: solid 2px #e5e5e5;
        .inner {
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
          border-radius: 26px;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
        .plus {
          position: absolute;
          right: -10px;
          bottom: -5px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          img {
            width: 100%;
          }
        }
      }
      .avatar-vip {
        border: solid 2px #dbbd80;
      }
    }
    .dropdown {
      position: relative;
      &:hover {
        .menu {
          display: block;
        }
      }
      .menu {
        display: none;
        position: absolute;
        top: 50px;
        right: -20px;
        width: 200px;
        padding: 10px 0;
        background: #ffffff;
        border: 1px solid #f1f1f1;
        box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        li {
          height: 40px;
          padding: 0;
          a {
            height: 40px;
            margin: 0;
            padding: 0 20px;
            line-height: 40px;
            &:hover {
              background: #fafafa;
              color: #151515;
            }
          }
        }
        .name {
          height: 88px;
          margin-top: -10px;
          padding: 20px;
          box-shadow: inset 0 -1px 0 0 #f1f1f1;
          .nickname {
            display: flex;
            align-items: center;
            line-height: 28px;
            .inner {
              display: inline-block;
              max-width: 120px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 18px;
              font-weight: bold;
            }
            img {
              width: 24px;
              margin-left: 10px;
            }
          }
          a {
            display: flex;
            align-items: center;
            height: 20px;
            padding: 0;
            line-height: 20px;
            color: #82b64a;
            &:hover {
              background: none;
              color: #74a342;
            }
            .icon {
              font-size: 20px;
            }
          }
        }
        .name-vip {
          background-image: linear-gradient(135deg, #f1e3b4 0%, #dbbd80 100%);
          a {
            color: #151515;
            &:hover {
              color: #151515;
            }
          }
        }
      }
    }
  }
  .header-mo {
    display: none;
  }
}

@media screen and (max-width: 1060px) {
  #pmcaffHeader {
    position: absolute;
    padding: 0 20px;
    .header-pc {
      display: none;
    }
    .header-mo {
      display: block;
    }
    .header-wrap {
      position: relative;
      height: 60px;
      z-index: 1;
      background: #fff;
    }
    .icon-arrow-down {
      display: block;
    }
    .icon-arrow-up {
      display: none;
    }
    .share-btn {
      padding: 10px;
      margin: 10px -10px;
      line-height: 20px;
      background: #fff;
      .icon-add {
        height: 20px;
        font-size: 20px;
        font-weight: bold;
        color: #82b64a;
      }
    }
    .count {
      min-width: 24px;
      height: 24px;
      margin: 18px -10px 0 10px;
      padding: 0 4px;
      line-height: 24px;
      border-radius: 24px;
      text-align: center;
      background: #82b64a;
      color: #fff;
    }
    .header-drawer {
      position: absolute;
      top: 60px;
      left: 0;
      width: 100%;
      height: 0;
      overflow: hidden;
      padding: 0 20px;
      background: #fff;
      ul {
        display: block;
        padding-bottom: 20px;
        li {
          padding: 10px 0;
          a {
            display: block;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            .text {
              color: #999;
              .hr {
                margin: 0 10px;
                color: #e5e5e5;
              }
            }
          }
        }
        .notices {
          .count {
            position: static;
            min-width: 30px;
            height: 30px;
            margin: 0;
            padding: 0 7px;
            line-height: 30px;
            border-radius: 30px;
            text-align: center;
            background: #82b64a;
            color: #fff;
          }
        }
        .icon {
          font-size: 20px;
          margin-left: 30px;
        }
        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 100%;
        }
        .hr {
          margin: 10px 0;
          padding: 0;
          border-top: solid 1px #f1f1f1;
        }
      }
    }
    &.nav-drawer-open {
      height: 100%;
      position: fixed;
      .header-mo {
        height: 100%;
      }
      .nav-drawer {
        height: 100%;
        top: 0;
        padding-top: 60px;
        overflow-y: auto;
      }
      .icon-arrow-down {
        display: none;
      }
      .icon-arrow-up {
        display: block;
      }
      .share-btn {
        display: none;
      }
    }
    &.write-drawer-open {
      height: auto;
      position: fixed;
      .share-btn {
        display: block;
        transform: rotate(45deg);
      }
      .write-drawer {
        height: auto;
        top: 0;
        padding-top: 60px;
        overflow-y: auto;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        .beans {
          display: none;
          color: #96b5a7;
        }
      }
      .icon-switch {
        display: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue